// eslint-disable-next-line import/no-cycle
import { useState } from 'react';
import { Section } from './Section';
import { GuidelinePage } from '../../model/GuidelinePage';
import { ImgErrorAlert } from './ImgErrorAlert';
import { MissingTitleAlert } from './MissingTitleAlert';
import { ContentProblemAlert } from './ContentProblemAlert';
import { applyTextReplacements } from './TextReplacements';

export type PageProps = {
  guideline: GuidelinePage;
  allPages: Map<string, GuidelinePage>;
  singlePageRender?: boolean;
  metaData?: Map<string, string>;
  textReplacements?: Map<string, string>;
};

export function Page({
  guideline,
  allPages,
  singlePageRender = false,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  metaData = new Map<string, string>(),
  textReplacements = new Map<string, string>(),
}: PageProps): JSX.Element {
  const [imgErrorUris, setImageErrorUris] = useState<string[]>([]);

  const imgErrorHandler = (uriString: string) => {
    if (!imgErrorUris.includes(uriString)) {
      setImageErrorUris([...imgErrorUris, uriString]);
    }
  };

  return (
    <div
      style={{ background: 'whitesmoke' }}
      data-cy={`guideline-sections-length: ${guideline.sections.length}`}
    >
      <ImgErrorAlert imgErrorUris={imgErrorUris} />
      <MissingTitleAlert title={guideline.title} />
      <ContentProblemAlert guideline={guideline} />

      {guideline.sections.map((section) => {
        const textReplacedSectionContent = applyTextReplacements(
          section.content,
          textReplacements
        );
        const newSection = { ...section, content: textReplacedSectionContent };
        return (
          <Section
            section={newSection}
            key={section.id}
            allPages={allPages}
            singlePageRender={singlePageRender}
            imgErrorHandler={imgErrorHandler}
          />
        );
      })}
    </div>
  );
}
